import Link from '@tiptap/extension-link';
import { mergeAttributes } from '@tiptap/core';
import { TEMPLATE_VALUE_ATTRIBUTE, getAttrs, renderHTMLAttrs } from './TemplateValue';

const CustomLink = Link.extend({
	addAttributes() {
		return {
			...this.parent?.(), // keep link attributes (href, target, etc.)
			...TEMPLATE_VALUE_ATTRIBUTE, // add template-value
			class: {
				default: null,
			},
			style: {
				default: null,
				parseHTML: (element) => element.getAttribute('style'),
				renderHTML: (attributes) => {
					if (!attributes.style) return {};
					return { style: attributes.style };
				},
			},

			contenteditable: {
				default: null,
				renderHTML: () => ({}),
			},
		};
	},

	parseHTML() {
		return [
			{
				tag: 'a',
				getAttrs: (element) => {
					return {
						...getAttrs(element),
						...this.parent?.().getAttrs?.(element),
						class: element.getAttribute('class'),
						style: element.getAttribute('style'),
					};
				},
			},
		];
	},

	renderHTML({ HTMLAttributes }) {
		return ['a', mergeAttributes(renderHTMLAttrs({ HTMLAttributes, editor: this.editor })), 0];
	},
});
export default CustomLink;
